import { StyleSheet } from 'aphrodite/no-important'
import { createStyle, XS_INDENT } from 'obap-core'

export const styles = StyleSheet.create({
  statusIcon: createStyle({
    paddingRight: XS_INDENT,
  }),
})
